import { render } from "./lot.vue?vue&type=template&id=c66b2a5e"
import script from "./lot.vue?vue&type=script&lang=js"
export * from "./lot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__